import React from 'react';
const idealFor = [{
  emoji: '👩‍🏫',
  label: 'Docentes de primaria'
}, {
  emoji: '🧑‍🏫',
  label: 'Maestras integradoras'
}, {
  emoji: '🧠',
  label: 'Psicopedagogas'
}, {
  emoji: '📚',
  label: 'Educación especial'
}, {
  emoji: '🤝',
  label: 'Acompañantes terapéuticos'
}, {
  emoji: '🏠',
  label: 'Familias'
}];
export function BeforeAfterSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-24" data-mp="zknfibf465x9">
      <div className="max-w-5xl mx-auto" data-id="element-25" data-mp="umvi51vp9rlo">
        <h2 className="text-[20px] font-black mb-2 text-center text-[#F9327E]" data-id="element-26" data-mp="um3npudu9zwz">
          IDEAL PARA:
        </h2>

        <p className="text-center text-gray-600 mb-6 text-base md:text-lg max-w-2xl mx-auto" data-id="element-27" data-mp="18m4rpipehngo">
          Un material pensado para quienes acompañan el aprendizaje desde
          distintos lugares.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-28" data-mp="3ag3z3szejko3">
          {idealFor.map((item, index) => <div key={index} className="bg-white rounded-2xl p-5 shadow-md border border-gray-100 flex flex-col items-center text-center hover:shadow-lg hover:border-[#F9327E] transition-all" data-id="element-29" data-mp="35haw4uhqrc26" data-mpi={index}>
              <span className="text-5xl mb-3" data-id="element-30" data-mp="3gm61m7hu0y3d">{item.emoji}</span>
              <p className="text-base md:text-lg font-bold text-gray-800" data-id="element-31" data-mp="3gkuz0b04hwdu">
                {item.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}